// extracted by mini-css-extract-plugin
export default {"menuInner":"Menu--menuInner--VT1wXSSF","menuItem":"Menu--menuItem--fTgh9MG_","caption":"Menu--caption--ggWcgZYR"};